module.exports = __webpack_public_path__ + "static/Muli-LightItalic-20fbec2366d80731c8dac8fe7b297fe0.ttf";